import ABCyaPhaser, { Fonts } from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import gameData from '../gameData';

export default class LevelDot extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, displayNum, dotColor, spriteName, circleSize, strokeSize, fontSize, fontColor) {
    super(scene);

    this.displayNum = displayNum;
    this.dotColor = dotColor;
    this.spritename = spriteName;
    this.circleSize = circleSize;
    this.strokeSize = strokeSize;
    this.fontSize = fontSize;
    this.fontColor = fontColor;

    this.bg = this.scene.add.circle(0, 0, this.circleSize * 0.5, dotColor);
    this.bg.setStrokeStyle(this.strokeSize, 0xffffff);
    this.add(this.bg);

    if (this.displayNum) {
      let fontSize = this.fontSize;
      let fontColor = this.fontColor;
      let displayNum = this.displayNum;
      if (gameData.isAlphabet) {
        let letters = "abcdefghijklmnopqrstuvwxyz";
        if (gameData.isUppercase) {
          displayNum = letters.charAt(this.displayNum - 1).toUpperCase();
        } else {
          displayNum = letters.charAt(this.displayNum - 1).toLowerCase();
        }
        if (displayNum === "j") {
          this.thej = ABCyaPhaser.Images.addImage(0, 0, "thej", this);
          displayNum = " ";
        }
      }

      if (displayNum > 99) {
        fontSize -= 6;
      }
      if (displayNum < 0) {
        displayNum = " ";
      }
      else {
        displayNum = displayNum.toString();
      }

      this.lblNum = ABCyaPhaser.Text.addText(0, 0, fontSize, fontColor, FontKeys._bpreplaybold, displayNum, this, true);
      ABCyaPhaser.Text.setFontStyle(this.lblNum, true);
      ABCyaPhaser.Text.setFontStyle(this.lblNum, true);
    }
  }

  updateDisplay(strokeColor, strokeSize, fillColor) {
    if (strokeSize < 1) {
      strokeColor = fillColor
      strokeSize = 1;
    }
    this.bg.setStrokeStyle(strokeSize, strokeColor);
    this.bg.setFillStyle(fillColor);
  }

  updateText(value) {
    this.lblNum.text = value.toString();
  }
}